export { default } from './ArticleDisclaimer';
export * from './ArticleDisclaimer';
